import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Text16 } from '../../../ui/Text16';

const Wrapper = styled.div`
  margin-top: 50px;
  width: 90%;
  max-width: 1400px;
`;

const BlockTitle = styled.h2`
  color: ${({ theme }) => theme.colors.blackColor};
  margin-top: 120px;
  text-align: center;
  margin-bottom: 80px;
  font-size: 48px;
`;

const DescriptionWrapper = styled.div<{ reverse?: boolean }>`
  display: flex;
  gap: 24px;
  margin: 100px 24px;

  @media (max-width: 1035px) {
    flex-direction: ${({ reverse }) => (reverse ? 'column-reverse' : 'column')};
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex: 1;
`;

const TitleText = styled.h3`
  color: ${({ theme }) => theme.colors.blackColor};
`;

const BlueText = styled.span`
  color: ${({ theme }) => theme.colors.accentBlue};
`;

const ImageWrapper = styled.div`
  flex: 1;
  text-align: center;
`;

const DescriptionImg = styled.img`
  height: 500px;
  @media (max-width: 1035px) {
    height: 260px;
  }
`;

const Description: React.FC<{}> = () => {
  const { t } = useTranslation();

  const description1 = (
    <DescriptionWrapper>
      <ImageWrapper>
        <DescriptionImg src='https://i.simpalsmedia.com/point.md/news/thumbnails/large/7bb6b1f5423e8a241c3dd3ccf6e79140.webp' />
      </ImageWrapper>
      <TextWrapper>
        <TitleText>
          <BlueText>{t('description_1_title_blue')}</BlueText>
          {t('description_1_title')}
        </TitleText>
        <Text16>{t('description_1_text1')}</Text16>
        <Text16>{t('description_1_text2')}</Text16>
      </TextWrapper>
    </DescriptionWrapper>
  );

  const description2 = (
    <DescriptionWrapper reverse={true}>
      <TextWrapper>
        <TitleText>
          <BlueText>{t('description_2_title_blue')}</BlueText>
          {t('description_2_title')}
        </TitleText>
        <Text16>{t('description_2_text1')}</Text16>
        <Text16>
          <ul>
            <li>{t('description_2_text2')}</li>
            <li>{t('description_2_text3')}</li>
            <li>{t('description_2_text4')}</li>
            <li>{t('description_2_text5')}</li>
            <li>{t('description_2_text6')}</li>
          </ul>
        </Text16>
        <Text16>{t('description_2_text7')}</Text16>
      </TextWrapper>
      <ImageWrapper>
        <DescriptionImg src='https://i.simpalsmedia.com/point.md/news/thumbnails/large/f35b7b195129d7989c094876afd82dbe.webp' />
      </ImageWrapper>
    </DescriptionWrapper>
  );

  const description3 = (
    <DescriptionWrapper>
      <ImageWrapper>
        <DescriptionImg src='https://i.simpalsmedia.com/point.md/news/thumbnails/large/07c9cc39eb4e2c0a2044a196f9cd43dc.webp' />
      </ImageWrapper>
      <TextWrapper>
        <TitleText>
          {t('description_3_title')}
          <BlueText>{t('description_3_title_blue')}</BlueText>
        </TitleText>
        <Text16>{t('description_3_text1')}</Text16>
        <Text16>{t('description_3_text2')}</Text16>
      </TextWrapper>
    </DescriptionWrapper>
  );

  const description4 = (
    <DescriptionWrapper reverse={true}>
      <TextWrapper>
        <TitleText>
          {t('description_4_title')}
          <BlueText>{t('description_4_title_blue')}</BlueText>
        </TitleText>
        <Text16>
          <ul style={{ listStyle: 'auto' }}>
            <li style={{ marginBottom: '15px' }}>{t('description_4_text1')}</li>
            <li style={{ marginBottom: '15px' }}>{t('description_4_text2')}</li>
            <li style={{ marginBottom: '15px' }}>{t('description_4_text3')}</li>
            <li style={{ marginBottom: '15px' }}>{t('description_4_text4')}</li>
            <li style={{ marginBottom: '15px' }}>{t('description_4_text5')}</li>
          </ul>
        </Text16>
      </TextWrapper>
      <ImageWrapper>
        <DescriptionImg src='https://i.simpalsmedia.com/point.md/news/thumbnails/large/579ecff7af5d20bfc0ba08a07b671d99.webp' />
      </ImageWrapper>
    </DescriptionWrapper>
  );

  return (
    <Wrapper>
      <BlockTitle>{t('description_title')}</BlockTitle>
      {description1}
      {description2}
      {description3}
      {description4}
    </Wrapper>
  );
};

export default Description;
